var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/BA-logo.png": "c58a",
	"./assets/Binance.png": "b636",
	"./assets/EU.png": "6ab6",
	"./assets/arrow-down-up.png": "59b6",
	"./assets/arrow-down.png": "a284",
	"./assets/arrow-up-down-white.png": "80e9",
	"./assets/arrow-up-down.png": "169b",
	"./assets/arrow-up.png": "f3a8",
	"./assets/bell.png": "6d0d",
	"./assets/binance-futures.png": "0769",
	"./assets/binance-logo.png": "953c",
	"./assets/bitcoin.png": "d706",
	"./assets/bitget_futures-logo.png": "e9e8",
	"./assets/bitvavo-logo-landing.png": "c608",
	"./assets/bitvavo-logo.png": "499d",
	"./assets/bitvavo.png": "98b0",
	"./assets/bots/PowerofPIMultiCoin2.png": "5d54",
	"./assets/bots/TopsandBottoms.png": "9259",
	"./assets/bots/bot_template.png": "8e9a",
	"./assets/bronze-icon.png": "9e15",
	"./assets/bronze.png": "8d31",
	"./assets/bybit_futures-logo.png": "96ea",
	"./assets/cart.png": "41b9",
	"./assets/charging-circle.png": "ef8f",
	"./assets/coins.jpg": "172d",
	"./assets/computer.png": "6333",
	"./assets/copy.png": "78a3",
	"./assets/dark.png": "03aa",
	"./assets/delete.png": "ed3a",
	"./assets/dots.png": "4eca",
	"./assets/drawdown-tooltip.png": "cd01",
	"./assets/edit-white.png": "f113",
	"./assets/edit.png": "aa93",
	"./assets/exchangeTutorials/binance/apiKeys/image.png": "6160",
	"./assets/exchangeTutorials/binance/apiKeys/step1.png": "f95e",
	"./assets/exchangeTutorials/binance/apiKeys/step2.png": "786f",
	"./assets/exchangeTutorials/binance/apiKeys/step3.png": "da06",
	"./assets/exchangeTutorials/binance/apiKeys/step4.png": "3a24",
	"./assets/exchangeTutorials/binance/apiKeys/step5.png": "dedf",
	"./assets/exchangeTutorials/binance/apiKeys/step6.png": "695d",
	"./assets/exchangeTutorials/binance/apiKeys/step7.png": "65fc",
	"./assets/exchangeTutorials/bitget/main_acc.png": "aa38",
	"./assets/exchangeTutorials/bitget/sub_acc.png": "375a",
	"./assets/exchangeTutorials/bitvavo/apiKeys/step1.png": "0c94",
	"./assets/exchangeTutorials/bitvavo/apiKeys/step2.png": "7029",
	"./assets/exchangeTutorials/bitvavo/apiKeys/step3.png": "8bcb",
	"./assets/exchangeTutorials/bitvavo/apiKeys/step4.png": "6ee9d",
	"./assets/exchangeTutorials/bitvavo/apiKeys/step5.png": "e965",
	"./assets/exchangeTutorials/bitvavo/apiKeys/step6.png": "28b0",
	"./assets/exchangeTutorials/bybit/apiKeys/step1.png": "6f29",
	"./assets/exchangeTutorials/bybit/apiKeys/step2.png": "5137",
	"./assets/exchangeTutorials/bybit/apiKeys/step3.png": "7c05",
	"./assets/exchangeTutorials/bybit/apiKeys/step4.png": "6ccf",
	"./assets/exchangeTutorials/bybit/apiKeys/step5.png": "1fbb",
	"./assets/exchangeTutorials/bybit/createAPIKeys/step1.png": "c3a5",
	"./assets/exchangeTutorials/bybit/createAPIKeys/step2.png": "85c0",
	"./assets/exchangeTutorials/bybit/createAPIKeys/step3.png": "bcbd",
	"./assets/exchangeTutorials/bybit/createAPIKeys/step4.png": "0ec5",
	"./assets/exchangeTutorials/bybit/createAPIKeys/step5.png": "7abd",
	"./assets/exchangeTutorials/bybit/createAPIKeys/step6.png": "baf6",
	"./assets/exchangeTutorials/bybit/createFundSubAccount/step1.png": "93f3",
	"./assets/exchangeTutorials/bybit/createFundSubAccount/step2.png": "c681",
	"./assets/exchangeTutorials/bybit/createFundSubAccount/step3.png": "0128",
	"./assets/exchangeTutorials/bybit/createFundSubAccount/step4.png": "f1c5",
	"./assets/exchangeTutorials/bybit/createFundSubAccount/step5.png": "d424",
	"./assets/exchangeTutorials/bybit/createFundSubAccount/step6.png": "3f8b",
	"./assets/exchangeTutorials/kraken/kraken_permissions.png": "b287",
	"./assets/exchangeTutorials/kucoin/kucoin_permissions.png": "7bfa",
	"./assets/exchangeTutorials/okx/apiKeys/step1.png": "7ff7",
	"./assets/exchangeTutorials/okx/apiKeys/step2.png": "1b67",
	"./assets/exchangeTutorials/okx/apiKeys/step3.png": "d864",
	"./assets/exchangeTutorials/okx/apiKeys/step4.png": "cd35",
	"./assets/exchangeTutorials/okx/apiKeys/step5.png": "66c9",
	"./assets/exchangeTutorials/okx/apiKeys/step6.png": "734d",
	"./assets/exchangeTutorials/okx/createAPIKeys/step1.png": "2d5c",
	"./assets/exchangeTutorials/okx/createAPIKeys/step2.png": "fd04",
	"./assets/exchangeTutorials/okx/createAPIKeys/step3.png": "9aa6",
	"./assets/exchangeTutorials/okx/createAPIKeys/step4.png": "a639",
	"./assets/exchangeTutorials/okx/createAPIKeys/step5.png": "2dec",
	"./assets/exchangeTutorials/okx/createFundSubAccount/step1.png": "0afe",
	"./assets/exchangeTutorials/okx/createFundSubAccount/step2.png": "a1a2",
	"./assets/exchangeTutorials/okx/createFundSubAccount/step3.png": "da22",
	"./assets/exchangeTutorials/okx/createFundSubAccount/step4.png": "03e9",
	"./assets/exchangeTutorials/okx/createFundSubAccount/step5.png": "b0eb",
	"./assets/exchanges.png": "4477",
	"./assets/expiry-icon.png": "a076",
	"./assets/filterArrowClose-white.png": "b810",
	"./assets/filterArrowClose.png": "f7e6",
	"./assets/filterArrowOpen-white.png": "6c9a",
	"./assets/filterArrowOpen.png": "cc0b",
	"./assets/filters-white.png": "1c3f",
	"./assets/filters.png": "1ac7",
	"./assets/footer-logo.png": "55a4",
	"./assets/ftx-logo-landing.png": "1d56",
	"./assets/ftx-logo-landing.svg": "0e3f",
	"./assets/ftx-logo.png": "3ade",
	"./assets/ftx.png": "62db",
	"./assets/gold.png": "caf4",
	"./assets/hamburger-gray.png": "bc12",
	"./assets/hamburger-white.png": "1e4b",
	"./assets/hamburger.png": "8b8f",
	"./assets/icon-exchange.png": "1b07",
	"./assets/icon.png": "555a",
	"./assets/invested.png": "b660",
	"./assets/json/landing": "c7ae",
	"./assets/json/landing.json": "c7ae",
	"./assets/kraken-white.png": "48af",
	"./assets/kraken_futures-logo.png": "7c89",
	"./assets/kucoin-logo.png": "13aa",
	"./assets/landing-background.jpg": "58d0",
	"./assets/landing/discord.png": "4556",
	"./assets/landing/email.png": "4e76",
	"./assets/landing/linkedin.png": "569e",
	"./assets/landing/twitter.png": "28d5",
	"./assets/landing/up-arrow-white.png": "855a",
	"./assets/landing/up-arrow.png": "1932",
	"./assets/light.png": "b448",
	"./assets/magnifying-glass.png": "8892",
	"./assets/maintenance.png": "b3d2",
	"./assets/mastercard.png": "7e5a",
	"./assets/notification/checked.png": "5ffc",
	"./assets/notification/cross.png": "39da",
	"./assets/notification/warning.png": "e78b",
	"./assets/notificationIcons/bell.png": "7f13",
	"./assets/notificationIcons/chart.png": "ab2f",
	"./assets/notificationIcons/gear.png": "f885",
	"./assets/notificationIcons/graph.png": "074f",
	"./assets/notificationIcons/newspaper.png": "4089",
	"./assets/notificationIcons/selected/bell-selected.png": "0a46",
	"./assets/notificationIcons/selected/chart-selected.png": "875f",
	"./assets/notificationIcons/selected/gear-selected.png": "1f8d",
	"./assets/notificationIcons/selected/graph-selected.png": "3981",
	"./assets/notificationIcons/selected/newspaper-selected.png": "7519",
	"./assets/notificationIcons/selected/system-selected.png": "74a4",
	"./assets/notificationIcons/system.png": "dc68",
	"./assets/okx_futures-logo.png": "9970",
	"./assets/pause.png": "88ae",
	"./assets/payment-methods/bancontact.png": "376c",
	"./assets/payment-methods/credit-card.png": "e2ad",
	"./assets/payment-methods/giropay.png": "8247",
	"./assets/payment-methods/ideal.png": "4c37",
	"./assets/payment-methods/paypal.png": "e257",
	"./assets/paypal-logo.png": "b489",
	"./assets/percentage-return.png": "29e2",
	"./assets/platformSideBar/bell.png": "f605",
	"./assets/platformSideBar/dashboard.png": "dc63",
	"./assets/platformSideBar/exchange.png": "57b9",
	"./assets/platformSideBar/gear.png": "e575",
	"./assets/platformSideBar/graph.png": "62c0",
	"./assets/platformSideBar/history.png": "abcd",
	"./assets/platformSideBar/information.png": "ee1d",
	"./assets/platformSideBar/logout.png": "fa1b",
	"./assets/platformSideBar/robot.png": "6ee9",
	"./assets/platformSideBar/selected/bell-selected.png": "3028",
	"./assets/platformSideBar/selected/dashboard-selected.png": "8425",
	"./assets/platformSideBar/selected/exchange-selected.png": "0cf7",
	"./assets/platformSideBar/selected/gear-selected.png": "120d",
	"./assets/platformSideBar/selected/graph-selected.png": "1feb",
	"./assets/platformSideBar/selected/history-selected.png": "252e",
	"./assets/platformSideBar/selected/information-selected.png": "dcd8",
	"./assets/platformSideBar/selected/logout.png": "107d",
	"./assets/platformSideBar/selected/robot-selected.png": "2e11",
	"./assets/play.png": "df84",
	"./assets/refresh.png": "684f",
	"./assets/reset-white.png": "b35c",
	"./assets/return.png": "f5a4",
	"./assets/risk-level.png": "ed5d",
	"./assets/roe-tooltip.png": "b0c2",
	"./assets/search-white.png": "f3b6",
	"./assets/search.png": "bbc5",
	"./assets/services/atom.png": "dc41",
	"./assets/services/gears.png": "a58f",
	"./assets/services/graph.png": "99b9",
	"./assets/services/key.png": "ffa7",
	"./assets/services/paper.png": "6ed2",
	"./assets/services/support.png": "0692",
	"./assets/settingsIcons/authentication.png": "837c",
	"./assets/settingsIcons/bell.png": "12ab",
	"./assets/settingsIcons/coin.png": "5159",
	"./assets/settingsIcons/email.png": "e51b",
	"./assets/settingsIcons/exchange.png": "66c3",
	"./assets/settingsIcons/padlock.png": "adb3",
	"./assets/settingsIcons/referral.png": "e45a",
	"./assets/settingsIcons/selected/authentication-selected.png": "908b",
	"./assets/settingsIcons/selected/bell-selected.png": "f65b",
	"./assets/settingsIcons/selected/coin-selected.png": "33e1",
	"./assets/settingsIcons/selected/email-selected.png": "5ae9",
	"./assets/settingsIcons/selected/exchange-selected.png": "7b25",
	"./assets/settingsIcons/selected/padlock-selected.png": "8fb9",
	"./assets/settingsIcons/selected/referral-selected.png": "5953",
	"./assets/settingsIcons/selected/subscription-selected.png": "1fb8",
	"./assets/settingsIcons/selected/user-selected.png": "e056",
	"./assets/settingsIcons/selected/white/authentication-selected-white.png": "9c8f",
	"./assets/settingsIcons/selected/white/bell-selected-white.png": "bf31",
	"./assets/settingsIcons/selected/white/coin-selected-white.png": "5773",
	"./assets/settingsIcons/selected/white/email-selected-white.png": "8133",
	"./assets/settingsIcons/selected/white/exchange-selected-white.png": "1f30",
	"./assets/settingsIcons/selected/white/padlock-selected-white.png": "0b02",
	"./assets/settingsIcons/selected/white/referral-selected-white.png": "8b45",
	"./assets/settingsIcons/selected/white/subscription-selected-white.png": "b90d",
	"./assets/settingsIcons/selected/white/user-selected-white.png": "37a9",
	"./assets/settingsIcons/subscription.png": "a519",
	"./assets/settingsIcons/user.png": "9004",
	"./assets/sharpratio-tooltip.png": "ed0c",
	"./assets/silver-icon.png": "6d11",
	"./assets/silver.png": "8e3c",
	"./assets/statistics/active-bots.png": "cae4",
	"./assets/statistics/best-bot.png": "9dbc",
	"./assets/statistics/coin.png": "276d",
	"./assets/statistics/loss-trade.png": "a276",
	"./assets/statistics/profit.png": "5b11",
	"./assets/statistics/win-trade.png": "f8a3",
	"./assets/technologies/chip.png": "eb8a",
	"./assets/technologies/knowledge.png": "c7c2",
	"./assets/technologies/neural.png": "a136",
	"./assets/technology.jpg": "1771",
	"./assets/telescope.jpeg": "66ab",
	"./assets/tooltip-white.png": "590f",
	"./assets/tooltip.png": "3a71",
	"./assets/total-return-blue.png": "9869",
	"./assets/trade-frequency.png": "695a",
	"./assets/trading-platform/bot-link.png": "d89f",
	"./assets/trading-platform/bots/icontest.png": "ce74",
	"./assets/trading-platform/drop-down-arrow.png": "665e",
	"./assets/trading-platform/eye-white.png": "49b7",
	"./assets/trading-platform/eye.png": "2c53",
	"./assets/trading-platform/invested.png": "584c",
	"./assets/trading-platform/percentage-return.png": "8f58",
	"./assets/trading-platform/register-bg.png": "286c",
	"./assets/trading-platform/shorts.png": "8fdd",
	"./assets/trading-platform/status.png": "f795",
	"./assets/trading-platform/tethericon.png": "fb1b",
	"./assets/trading-platform/total-return.png": "a732",
	"./assets/tradingCoins.png": "185d",
	"./assets/user.png": "c121",
	"./assets/video/background720.mp4": "f4f0",
	"./assets/visa-credit-card-icon-18.png": "a630",
	"./assets/visa.png": "4b12",
	"./assets/warning.png": "73f5",
	"./components/shared/ArrowHeadDown": "70e7",
	"./components/shared/ArrowHeadDown.vue": "70e7",
	"./components/shared/ArrowHeadUp": "fa4a",
	"./components/shared/ArrowHeadUp.vue": "fa4a",
	"./components/shared/BotSpecifics": "628c",
	"./components/shared/BotSpecifics.vue": "628c",
	"./components/shared/BotTableItem": "9bc5",
	"./components/shared/BotTableItem.vue": "9bc5",
	"./components/shared/DurationSelector": "ebdd",
	"./components/shared/DurationSelector.vue": "ebdd",
	"./components/shared/LineGraph": "5d1d",
	"./components/shared/LineGraph.vue": "5d1d",
	"./components/shared/Loading": "50eb",
	"./components/shared/Loading.vue": "50eb",
	"./components/shared/Metrics": "35de",
	"./components/shared/Metrics.vue": "35de",
	"./components/shared/ModifySubscriptionPaymentForm": "2a67",
	"./components/shared/ModifySubscriptionPaymentForm.vue": "2a67",
	"./components/shared/Notification": "6d4f",
	"./components/shared/Notification.vue": "6d4f",
	"./components/shared/PaymentForm": "50f1",
	"./components/shared/PaymentForm.vue": "50f1",
	"./components/shared/Selector": "51ff",
	"./components/shared/Selector.vue": "51ff",
	"./components/shared/ShortsToggleSwitch": "2d8b",
	"./components/shared/ShortsToggleSwitch.vue": "2d8b",
	"./components/shared/ToggleSwitch": "8445",
	"./components/shared/ToggleSwitch.vue": "8445",
	"./components/shared/exchanges/ExchangeSelector": "f35e",
	"./components/shared/exchanges/ExchangeSelector.vue": "f35e",
	"./components/shared/exchanges/NewExchange": "2d47",
	"./components/shared/exchanges/NewExchange.vue": "2d47",
	"./components/shared/exchanges/botSelectedExchange": "2169",
	"./components/shared/exchanges/botSelectedExchange.vue": "2169",
	"./components/shared/modals/AlertModal": "5601",
	"./components/shared/modals/AlertModal.vue": "5601",
	"./components/shared/modals/BetaDisclaimer": "0d1c",
	"./components/shared/modals/BetaDisclaimer.vue": "0d1c",
	"./components/shared/modals/CancelSubscriptionModal": "3107",
	"./components/shared/modals/CancelSubscriptionModal.vue": "3107",
	"./components/shared/modals/ErrorModal": "67b4",
	"./components/shared/modals/ErrorModal.vue": "67b4",
	"./components/shared/modals/ForgotPasswordModal": "7782",
	"./components/shared/modals/ForgotPasswordModal.vue": "7782",
	"./components/shared/modals/FreeTrialModal": "fbbb",
	"./components/shared/modals/FreeTrialModal.vue": "fbbb",
	"./components/shared/modals/Modal": "da35",
	"./components/shared/modals/Modal.vue": "da35",
	"./components/shared/modals/ModifySubscriptionModal": "f534",
	"./components/shared/modals/ModifySubscriptionModal.vue": "f534",
	"./components/shared/modals/NewBotModal": "3633",
	"./components/shared/modals/NewBotModal.vue": "3633",
	"./components/shared/modals/OTPModal": "2e75",
	"./components/shared/modals/OTPModal.vue": "2e75",
	"./components/shared/modals/PaymentConfirmationModal": "ee4f",
	"./components/shared/modals/PaymentConfirmationModal.vue": "ee4f",
	"./components/shared/modals/PaymentModal": "a00c",
	"./components/shared/modals/PaymentModal.vue": "a00c",
	"./components/shared/modals/PaypalPaymentModal": "2bc6",
	"./components/shared/modals/PaypalPaymentModal.vue": "2bc6",
	"./components/shared/modals/QRModal": "89a1",
	"./components/shared/modals/QRModal.vue": "89a1",
	"./components/shared/modals/ResetPNLModal": "a888",
	"./components/shared/modals/ResetPNLModal.vue": "a888",
	"./components/shared/modals/ResumeSubscriptionModal": "57de",
	"./components/shared/modals/ResumeSubscriptionModal.vue": "57de",
	"./components/shared/modals/StopBotModal": "6313",
	"./components/shared/modals/StopBotModal.vue": "6313",
	"./components/shared/modals/SubscriptionModal": "1ed4",
	"./components/shared/modals/SubscriptionModal.vue": "1ed4",
	"./components/shared/modals/UpdatePaymentModal": "c667",
	"./components/shared/modals/UpdatePaymentModal.vue": "c667",
	"./components/shared/modals/UpdateSubscriptionModal": "0818",
	"./components/shared/modals/UpdateSubscriptionModal.vue": "0818",
	"./components/shared/modals/VerificationCodeModal": "b21a",
	"./components/shared/modals/VerificationCodeModal.vue": "b21a",
	"./components/trading/ActiveMarketplaceFilters": "79cf",
	"./components/trading/ActiveMarketplaceFilters.vue": "79cf",
	"./components/trading/ActivityFilters": "0d6a",
	"./components/trading/ActivityFilters.vue": "0d6a",
	"./components/trading/BalanceOverview": "5feb",
	"./components/trading/BalanceOverview.vue": "5feb",
	"./components/trading/BetaRegister": "00de",
	"./components/trading/BetaRegister.vue": "00de",
	"./components/trading/BillingDetails": "72c0",
	"./components/trading/BillingDetails.vue": "72c0",
	"./components/trading/BotFilter": "6b24",
	"./components/trading/BotFilter.vue": "6b24",
	"./components/trading/BotFilters": "a2e3",
	"./components/trading/BotFilters.vue": "a2e3",
	"./components/trading/BotOverview": "d943",
	"./components/trading/BotOverview.vue": "d943",
	"./components/trading/CartItem": "b5af",
	"./components/trading/CartItem.vue": "b5af",
	"./components/trading/DashboardMetrics": "4db6",
	"./components/trading/DashboardMetrics.vue": "4db6",
	"./components/trading/Dropdown": "70ba",
	"./components/trading/Dropdown.vue": "70ba",
	"./components/trading/Filters": "f0fe",
	"./components/trading/Filters.vue": "f0fe",
	"./components/trading/HistoricalPositions": "a1bd",
	"./components/trading/HistoricalPositions.vue": "a1bd",
	"./components/trading/MarkterPlaceFilters": "9c73",
	"./components/trading/MarkterPlaceFilters.vue": "9c73",
	"./components/trading/NewExchangeAccount": "7888",
	"./components/trading/NewExchangeAccount.vue": "7888",
	"./components/trading/Pagination": "a74f",
	"./components/trading/Pagination.vue": "a74f",
	"./components/trading/SideBar": "925b",
	"./components/trading/SideBar.vue": "925b",
	"./components/trading/TimeFilterDropdown": "028e",
	"./components/trading/TimeFilterDropdown.vue": "028e",
	"./components/trading/TopBar": "78e6",
	"./components/trading/TopBar.vue": "78e6",
	"./components/trading/UpdateExchangeDropdown": "c7a8",
	"./components/trading/UpdateExchangeDropdown.vue": "c7a8",
	"./components/trading/bots/BotBadge": "f5ef",
	"./components/trading/bots/BotBadge.vue": "f5ef",
	"./components/trading/bots/BotCard": "7f0c",
	"./components/trading/bots/BotCard.vue": "7f0c",
	"./components/trading/bots/BotCardGraph": "1645",
	"./components/trading/bots/BotCardGraph.vue": "1645",
	"./components/trading/bots/BotExchange": "cade",
	"./components/trading/bots/BotExchange.vue": "cade",
	"./components/trading/bots/MobileBotCard": "2c02",
	"./components/trading/bots/MobileBotCard.vue": "2c02",
	"./components/trading/bots/PromotedBots": "244b",
	"./components/trading/bots/PromotedBots.vue": "244b",
	"./components/trading/bots/SubscribedBotCard": "9ba8",
	"./components/trading/bots/SubscribedBotCard.vue": "9ba8",
	"./components/trading/charts/BarChart": "4c49",
	"./components/trading/charts/BarChart.vue": "4c49",
	"./components/trading/charts/PieChart": "ef95",
	"./components/trading/charts/PieChart.vue": "ef95",
	"./components/trading/settings/ChangeEmail": "2af6",
	"./components/trading/settings/ChangeEmail.vue": "2af6",
	"./components/trading/settings/ChangePassword": "b2a6",
	"./components/trading/settings/ChangePassword.vue": "b2a6",
	"./components/trading/settings/ConnectedExchanges": "f3f2",
	"./components/trading/settings/ConnectedExchanges.vue": "f3f2",
	"./components/trading/settings/NotificationSettings": "aabc",
	"./components/trading/settings/NotificationSettings.vue": "aabc",
	"./components/trading/settings/PaymentMethods": "2224",
	"./components/trading/settings/PaymentMethods.vue": "2224",
	"./components/trading/settings/Profile": "af4f",
	"./components/trading/settings/Profile.vue": "af4f",
	"./components/trading/settings/ReferralCode": "5ea6",
	"./components/trading/settings/ReferralCode.vue": "5ea6",
	"./components/trading/settings/Subscriptions": "f700",
	"./components/trading/settings/Subscriptions.vue": "f700",
	"./components/trading/settings/ThemeToggle": "b137",
	"./components/trading/settings/ThemeToggle.vue": "b137",
	"./components/trading/settings/TwoFactor": "63eb",
	"./components/trading/settings/TwoFactor.vue": "63eb",
	"./components/trading/settings/exchanges/ConnectBinanceAccount": "37e5",
	"./components/trading/settings/exchanges/ConnectBinanceAccount.vue": "37e5",
	"./components/trading/settings/exchanges/ConnectBitgetAccount": "dd6a",
	"./components/trading/settings/exchanges/ConnectBitgetAccount.vue": "dd6a",
	"./components/trading/settings/exchanges/ConnectBitvavoAccount": "7164",
	"./components/trading/settings/exchanges/ConnectBitvavoAccount.vue": "7164",
	"./components/trading/settings/exchanges/ConnectBybitAccount": "e9cb",
	"./components/trading/settings/exchanges/ConnectBybitAccount.vue": "e9cb",
	"./components/trading/settings/exchanges/ConnectFtxAccount": "4838",
	"./components/trading/settings/exchanges/ConnectFtxAccount.vue": "4838",
	"./components/trading/settings/exchanges/ConnectKrakenAccount": "0f69",
	"./components/trading/settings/exchanges/ConnectKrakenAccount.vue": "0f69",
	"./components/trading/settings/exchanges/ConnectKucoinAccount": "eed3",
	"./components/trading/settings/exchanges/ConnectKucoinAccount.vue": "eed3",
	"./components/trading/settings/exchanges/ConnectOkxAccount": "6248",
	"./components/trading/settings/exchanges/ConnectOkxAccount.vue": "6248",
	"./components/trading/settings/exchanges/tutorials/exchangeTutorial": "3232",
	"./components/trading/settings/exchanges/tutorials/exchangeTutorial.vue": "3232",
	"./components/trading/statistics/BotStats": "4d04",
	"./components/trading/statistics/BotStats.vue": "4d04",
	"./components/trading/statistics/StatsCard": "a3e4",
	"./components/trading/statistics/StatsCard.vue": "a3e4",
	"./components/trading/statistics/StatsOverview": "98d7",
	"./components/trading/statistics/StatsOverview.vue": "98d7",
	"./components/trading/subscribeBot/AllocateAmount": "0c1f",
	"./components/trading/subscribeBot/AllocateAmount.vue": "0c1f",
	"./components/trading/subscribeBot/ConnectExchange": "6fca",
	"./components/trading/subscribeBot/ConnectExchange.vue": "6fca",
	"./components/trading/subscribeBot/NewExchangeAccount": "3ca34",
	"./components/trading/subscribeBot/NewExchangeAccount.vue": "3ca34",
	"./components/trading/subscribeBot/SelectBot": "cba0",
	"./components/trading/subscribeBot/SelectBot.vue": "cba0",
	"./components/trading/subscribeBot/ShortsToggle": "7987",
	"./components/trading/subscribeBot/ShortsToggle.vue": "7987",
	"./components/trading/subscribeBot/SubscriptionDuration": "8248",
	"./components/trading/subscribeBot/SubscriptionDuration.vue": "8248",
	"./components/trading/subscribeBot/SubscriptionPlan": "f6f1",
	"./components/trading/subscribeBot/SubscriptionPlan.vue": "f6f1",
	"./json/Einstein-EN": "1c69",
	"./json/Einstein-EN.json": "1c69",
	"./json/EinsteinNL": "0fe5",
	"./json/EinsteinNL.json": "0fe5",
	"./json/FAQJson": "ea24",
	"./json/FAQJson.json": "ea24",
	"./json/MarketPlaceFilters": "4f60",
	"./json/MarketPlaceFilters.json": "4f60",
	"./json/binanceTutorial": "cafa",
	"./json/binanceTutorial.json": "cafa",
	"./json/bitgetTutorial": "1b21",
	"./json/bitgetTutorial.json": "1b21",
	"./json/bitvavoTutorial": "90c4",
	"./json/bitvavoTutorial.json": "90c4",
	"./json/bybitTutorial": "4002",
	"./json/bybitTutorial.json": "4002",
	"./json/descriptions": "839d",
	"./json/descriptions.json": "839d",
	"./json/disclaimer": "3d3f",
	"./json/disclaimer.json": "3d3f",
	"./json/filters": "72fd",
	"./json/filters.json": "72fd",
	"./json/krakenTutorial": "856a",
	"./json/krakenTutorial.json": "856a",
	"./json/kucoinTutorial": "5f10",
	"./json/kucoinTutorial.json": "5f10",
	"./json/okxTutorial": "d385",
	"./json/okxTutorial.json": "d385",
	"./json/privacyPolicy": "3ca9",
	"./json/privacyPolicy.json": "3ca9",
	"./json/termsConditions": "5ab2",
	"./json/termsConditions.json": "5ab2",
	"./json/userStats": "24f7",
	"./json/userStats.json": "24f7",
	"./main": "56d7",
	"./main.js": "56d7",
	"./plugins/vuetify": "402c",
	"./plugins/vuetify.js": "402c",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./store/modules/bots": "d31b",
	"./store/modules/bots.js": "d31b",
	"./store/modules/cart": "499b",
	"./store/modules/cart.js": "499b",
	"./store/modules/exchanges": "d86e",
	"./store/modules/exchanges.js": "d86e",
	"./store/modules/marketplace": "96fe",
	"./store/modules/marketplace.js": "96fe",
	"./store/modules/newBot": "4abb",
	"./store/modules/newBot.js": "4abb",
	"./store/modules/notification": "779a",
	"./store/modules/notification.js": "779a",
	"./store/modules/user": "0f9a",
	"./store/modules/user.js": "0f9a",
	"./views/trading/Activity": "7821",
	"./views/trading/Activity.vue": "7821",
	"./views/trading/Bot": "e882",
	"./views/trading/Bot.vue": "e882",
	"./views/trading/CopyTrading": "2eb3",
	"./views/trading/CopyTrading.vue": "2eb3",
	"./views/trading/Dashboard": "18be",
	"./views/trading/Dashboard.vue": "18be",
	"./views/trading/ExchangeAccounts": "27b3",
	"./views/trading/ExchangeAccounts.vue": "27b3",
	"./views/trading/Login": "03e7",
	"./views/trading/Login.vue": "03e7",
	"./views/trading/Marketplace": "7182",
	"./views/trading/Marketplace.vue": "7182",
	"./views/trading/Notifications": "3bd7",
	"./views/trading/Notifications.vue": "3bd7",
	"./views/trading/Settings": "1ff5",
	"./views/trading/Settings.vue": "1ff5",
	"./views/trading/Statistics": "ef9b",
	"./views/trading/Statistics.vue": "ef9b",
	"./views/trading/SubscribedBot": "c80d",
	"./views/trading/SubscribedBot.vue": "c80d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";